import { EDjangoAppsEndpoints } from '../enums/EDjangoAppsEndpoints';
import type { IAugmentedBackendResponse } from '../models/IAugmentedBackendResponse';
import { type ILocalisationEntry } from '../models/ILocalisationEntry';
import type { ILocalisationEntryPostBody } from '../models/ILocalisationEntryPostBody';
import type { ILocalisationEntryResponse } from '../models/ILocalisationEntryResponse';
import { type ISortingMeta } from '../models/ISortingMeta';
import type { TPandasTable } from '../models/TPandasTable';
import CoreJsonAPIService from './CoreJsonAPIService';

export class SvLocalisationService extends CoreJsonAPIService {
  static async getLocalisationTable(params: {
    page: number;
    search: string;
    sorting: ISortingMeta;
    filters?: string[];
  }) {
    return await super.get<IAugmentedBackendResponse<TPandasTable>>(EDjangoAppsEndpoints.i18nLocalisation, '/multi', {
      page: params.page,
      searchText: params.search,
      sortCol: params.sorting.sortCol,
      ascending: params.sorting.ascending,
      filters: params.filters?.join(',')
    });
  }

  static async getSingleLocalisationEntry(params: { textKey: string }) {
    return await super.get<ILocalisationEntry>(EDjangoAppsEndpoints.i18nLocalisation, 'single', params);
  }

  static async postSingleLocalisationEntry(body: ILocalisationEntryPostBody) {
    return await super.post<ILocalisationEntryResponse>(EDjangoAppsEndpoints.i18nLocalisation, 'single', body);
  }

  static async downloadI18nFile(params: { type: 'frontend' | 'backend' | 'homepage' }) {
    return await super.getFileResponse(EDjangoAppsEndpoints.i18nLocalisation, 'language-file', { mode: params.type });
  }

  static async uploadI18nFile(params: { mode: 'backend' | 'frontend' | 'homepage'; file: File; replaceMode: boolean }) {
    const fd = new FormData();
    fd.append('mode', params.mode);
    fd.append('file', params.file);
    fd.append('replaceMode', params.replaceMode.toString());
    return await super.post<{
      changed: number;
      retained: number;
      deactivated: number;
    }>(EDjangoAppsEndpoints.i18nLocalisation, 'file', fd as any);
  }
}
